// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { Login } from './components/Login';
import HoopsAnalyst from './components/HoopsAnalyst';
import BlogHomepage from './components/blog/BlogHomepage';
import SubscriptionGate from './components/SubscriptionGate';
import ResetPassword from './components/ResetPassword';

// ── Auth + Subscription guard ──────────────────────────────────────────────
// 1. Not authenticated → show Login
// 2. Authenticated but not premium → show SubscriptionGate
// 3. Authenticated + premium → show the app
const ProtectedRoute = ({ children }) => {
  const { user, loading, isPremium } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4" />
          <p className="text-white text-lg">Loading Hoops Analyst...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Login />;
  if (!isPremium) return <SubscriptionGate />;

  return children;
};

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<BlogHomepage />} />
            <Route path="/blog" element={<BlogHomepage />} />

            {/* Password reset — accessible without a subscription */}
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected analytics app routes */}
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <HoopsAnalyst />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/:playerSlug"
              element={
                <ProtectedRoute>
                  <HoopsAnalyst />
                </ProtectedRoute>
              }
            />

            {/* Fallback to blog */}
            <Route path="*" element={<BlogHomepage />} />
          </Routes>
        </Router>
      </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
